const calculators = [
  { name: "Plates Calculator", to: "/plates" },
  { name: "One Rep Max Calculator", to: "/one-rep-max" },
  {
    name: "Optimal Reps Calculator",
    to: "/optimal-reps",
  },
  {
    name: "Warm Up Sets Calculator",
    to: "/warm-up-sets",
  },
];

export default calculators;
